module.exports = __webpack_public_path__ + "img/dumper.17fba0e.png";